var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocaleVerti = function SvgLocaleVerti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 64a320 320 0 0 0-320 320v19.285c0 70.699 22.101 139.648 63.19 197.206L512 960l256.81-359.51A339.285 339.285 0 0 0 832 403.286V384A320 320 0 0 0 512 64zm0 192a128 128 0 1 1 0 256 128 128 0 0 1 0-256z"
  })));
};
export default SvgLocaleVerti;